import React from 'react';
import { FeedbackType } from '../../components/App/Content/UserDeveloper/Submission/submission-graphql';
import { StyledBodyText } from '../Styleguide/Common/Text';
import { formatGraphDateAndTime } from '../formatting';
import { Box } from '@mui/system';
import { COLORS } from '../Styleguide/Common/colors';
import moment from 'moment';

export interface FeedbackProps {
  feedback: FeedbackType;
}

const Feedback: React.FC<FeedbackProps> = ({ feedback }) => {
  return (
    <Box sx={{ maxHeight: 500, overflowY: 'auto', border: `1px solid ${COLORS.black[40]}`, borderRadius: 1, p: 1 }}>
      {feedback.length === 0 && <p>There is no feedback yet on this submission.</p>}
      {feedback
        .slice(0)
        .sort((a, b) => moment.utc(b.postedOn).diff(moment.utc(a.postedOn)))
        .map((entry) => (
          <Box sx={{ mb: 1 }} key={`${entry.postedOn}`}>
            <StyledBodyText>
              <strong>{entry.authorName}</strong> on {formatGraphDateAndTime(entry.postedOn)}
            </StyledBodyText>

            <div>
              <em>
                <StyledBodyText color="white60" sx={{ whiteSpace: 'pre-line', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                  {entry.comment}
                </StyledBodyText>
              </em>
            </div>
          </Box>
        ))}
    </Box>
  );
};

export default Feedback;
